module.exports = __webpack_public_path__ + "static/media/hardwood-classic.181ed14d.jpeg";